export default __webpack_public_path__ + "static/21_31-2dff819a6b2d42e5ffe65aa06ae5e3d5.png";